import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=b2fdf856&scoped=true"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"
import style0 from "./Panel.vue?vue&type=style&index=0&id=b2fdf856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fdf856",
  null
  
)

export default component.exports